import { render, staticRenderFns } from "./share.vue?vue&type=template&id=667acf48&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"
import style0 from "./share.vue?vue&type=style&index=0&id=667acf48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667acf48",
  null
  
)

export default component.exports